import React, { useState, useRef, useEffect } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
  Polygon,
} from "@react-google-maps/api";
import useGetGrievances from "./useGetGrievances";
import indiaShape from "../../../../src/assets/geoJsonData/india-composite.json";
import { mapStyles } from "../../../utils/mapStyles";
import { FullscreenOutlined, CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { priorityIcons } from "../../../utils/priorityIcons";
import { statusIcons } from "../../../utils/statusIcons";
import MarkerInfoContent from "./MarkerInfoContent";
import {
  lib,
  indiaCenter,
  initialZoom,
  indiaBounds,
} from "../../../utils/mapConstants";
import useGeoData from "../../../Components/cdm/AssemblyMap/useGeoData";
import useProcessGeoData from "../../../Components/cdm/AssemblyMap/useProcessGeoData";
import { Select } from "antd";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import { useQuery } from "react-query";
import { Tooltip } from "antd";

const loggedInUser = JSON.parse(localStorage.getItem("user"));
const MapBox = (props) => {
  const axiosInstance = useAxiosInstance();
  const {
    priorityClick,
    statusClick,
    newGrievanceData,
    constituencyData,
    villagesList,
  } = props;
  const themes = localStorage.getItem("themes");
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: lib,
  });
  const { grievances, loading } = useGetGrievances(
    isLoaded,
    priorityClick,
    statusClick,
    newGrievanceData
  );
  const [activeMarker, setActiveMarker] = useState(null);
  const [showingInfoWindow, setShowingInfoWindow] = useState(false);
  const [polygonPaths, setPolygonPaths] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState({});
  const constituencyDataType = constituencyData?.data?.type;
  const [polyData, setPolyData] = useGeoData(constituencyData?.data?._id);

  useProcessGeoData(polyData, isLoaded, setPolygonPaths);

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isActive, setIsActive] = useState(false);

  // const toggleFullScreen = () => {
  //   const mapContainer = document.querySelector(".map-container");

  //   if (!mapContainer) return;

  //   if (!isFullScreen) {
  //     if (mapContainer.requestFullscreen) {
  //       mapContainer.requestFullscreen();
  //     } else if (mapContainer.webkitRequestFullscreen) {
  //       mapContainer.webkitRequestFullscreen();
  //     } else if (mapContainer.mozRequestFullScreen) {
  //       mapContainer.mozRequestFullScreen();
  //     } else if (mapContainer.msRequestFullscreen) {
  //       mapContainer.msRequestFullscreen();
  //     }
  //   } else {
  //     if (document.exitFullscreen) {
  //       document.exitFullscreen();
  //     } else if (document.webkitExitFullscreen) {
  //       document.webkitExitFullscreen();
  //     } else if (document.mozCancelFullScreen) {
  //       document.mozCancelFullScreen();
  //     } else if (document.msExitFullscreen) {
  //       document.msExitFullscreen();
  //     }
  //   }

  //   setIsFullScreen(!isFullScreen);
  // };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
    
  };

  const mapRef = useRef(null);
  let mapStyle;
  if (themes && themes === "darkMode") {
    mapStyle = [
      {
        elementType: "geometry",
        stylers: [{ color: "#1a2332" }],
      },
      {
        elementType: "labels.text.fill",
        stylers: [{ color: "#ffffff" }],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#1a2332" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#4a6fa5" }, { lightness: -10 }],
      },
      {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [{ color: "#64779f" }],
      },
      {
        featureType: "administrative.province",
        elementType: "geometry.stroke",
        stylers: [{ color: "#4a6fa5" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#263238" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.man_made",
        elementType: "geometry.stroke",
        stylers: [{ color: "#334e87" }],
      },
      {
        featureType: "landscape.natural",
        elementType: "geometry",
        stylers: [{ color: "#263238" }],
      },
      {
        featureType: "road",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#0e1626" }],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#4e6d70" }],
      },
    ];
  }

  useEffect(() => {
    if (
      polygonPaths &&
      Array.isArray(polygonPaths) &&
      polygonPaths.length > 0
    ) {
      const bounds = new window.google.maps.LatLngBounds();
      polygonPaths.forEach((polygon) => {
        polygon?.coordinate.forEach((item) => {
          bounds.extend(new window.google.maps.LatLng(item?.lat, item?.lng));
        });
      });
      const polygonCenter = bounds.getCenter();
      mapRef.current.fitBounds(bounds);
      mapRef.current.setCenter(polygonCenter);
    }
  }, [polygonPaths, constituencyData]);

  const fetchGrievanceInsightsByUserRole = async (villageId) => {
    let response;
    if (villageId) {
      response = await axiosInstance.get(
        `api/grievances/grievanceInsightsByUserRole${
          villageId ? `?villageId=${villageId}` : ""
        }`
      );
    } else {
      response = await axiosInstance.get(
        `api/grievances/grievanceInsightsByUserRole`
      );
    }

    return response || [];
  };

  const {
    data: grievanceInsightsDataByRole,
    isLoading: insightsLoading,
    error: insightsError,
  } = useQuery(
    ["insights-data", selectedMarker?._id || "all"], // use "all" for no village
    () => fetchGrievanceInsightsByUserRole(selectedMarker?._id),
    {
      refetchOnWindowFocus: false, // prevent aggressive reloading
      retry: 1,
    }
  );

  const fetchGrievanceInsightsByOffice = async (villageId) => {
    let response;
    if (villageId) {
      response = await axiosInstance.get(
        `api/grievances/grievanceInsightsByOffice${
          villageId ? `?villageId=${villageId}` : ""
        }`
      );
    } else {
      response = await axiosInstance.get(
        `api/grievances/grievanceInsightsByOffice`
      );
    }

    return response || [];
  };

  const {
    data: grievanceInsightsDataByOffice,
    isLoading: insightsOfficeLoading,
    error: insightsOfficeError,
  } = useQuery(
    ["insights-data-office", selectedMarker?._id || "all"], // use "all" for no village
    () => fetchGrievanceInsightsByOffice(selectedMarker?._id),
    {
      refetchOnWindowFocus: false, // prevent aggressive reloading
      retry: 1,
    }
  );

  const onCloseInfoWindow = () => {
    setActiveMarker(null);
    setShowingInfoWindow(false);
    const numSteps = 10;
    const targetZoom = 11;
    const currentZoom = mapRef.current.getZoom();
    const step = (targetZoom - currentZoom) / numSteps;
    // Smoothly zoom out
    for (let i = 1; i <= numSteps; i++) {
      setTimeout(() => {
        const newZoom = currentZoom + step * i;
        // mapRef.current.setZoom(7);
        mapRef.current.setZoom(newZoom);
      }, 80 * i);
    }
  };

  const onMarkerClick = (marker) => {
    setActiveMarker(marker);
    setShowingInfoWindow(true);

    const markerLatLng = new window.google.maps.LatLng(
      marker.geometry.coordinates[1],
      marker.geometry.coordinates[0]
    );
    if (mapRef.current) {
      const targetZoom = 15;
      const currentZoom = mapRef.current.getZoom();
      const numSteps = 10;
      const step = (targetZoom - currentZoom) / numSteps;

      // Smoothly zoom in
      for (let i = 1; i <= numSteps; i++) {
        setTimeout(() => {
          const newZoom = currentZoom + step * i;
          mapRef.current.setZoom(newZoom);
          mapRef.current.panTo(markerLatLng);
        }, 80 * i);
      }
    }
  };

  const onLoad = (map) => {
    mapRef.current = map;
    map.data.addGeoJson(indiaShape);
    map.data.setStyle((feature) => {
      return {
        fillColor: "white",
        fillOpacity: 0.1,
        strokeColor: "black",
        strokeWeight: 1,
        strokeOpacity: 0.1,
      };
    });
  };

  const renderInfoWindow = () => {
    if (activeMarker && showingInfoWindow)
      return (
        <InfoWindow
          position={{
            lat: activeMarker?.geometry?.coordinates?.[1],
            lng: activeMarker?.geometry?.coordinates?.[0],
          }}
          visible={showingInfoWindow}
          onCloseClick={onCloseInfoWindow}
        >
          <MarkerInfoContent activeMarker={activeMarker} />
        </InfoWindow>
      );
  };

  const renderGrievanceMarkers = () => {
    return grievances.map((grievance, index) => {
      const coordinates = grievance?.geometry?.coordinates;
      if (
        coordinates &&
        coordinates.length === 2 &&
        typeof coordinates[0] === "number" &&
        typeof coordinates[1] === "number" &&
        grievance?.properties?.status !== "complete"
      ) {
        return (
          <Marker
            icon={{
              url: statusIcons[grievance?.properties?.status],
              scaledSize: new window.google.maps.Size(30, 30),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
            }}
            key={index}
            title={grievance?.properties?.title || "No Title"}
            position={{
              lat: coordinates[1],
              lng: coordinates[0],
            }}
            onClick={() => {
              onMarkerClick(grievance);
            }}
          />
        );
      } else {
        return null;
      }
    });
  };

  const renderConstituencyPolygons = () => {
    if (!polygonPaths || !Array.isArray(polygonPaths)) return null;
    return polygonPaths.map((polygon, index) => {
      const bounds = new window.google.maps.LatLngBounds();
      polygon?.coordinate.forEach((point) => {
        const lat = Number(point?.lat);
        const lng = Number(point?.lng);
        if (!isNaN(lat) && !isNaN(lng)) {
          bounds.extend({ lat, lng });
        } else {
          console.error("Invalid coordinateP:", point?.lat);
        }
      });
      const center = bounds.getCenter();

      return (
        <React.Fragment key={index}>
          <Polygon
            key={index}
            paths={polygon?.coordinate
              ?.map((point) => ({
                lat: Number(point?.lat),
                lng: Number(point?.lng),
              }))
              .filter((point) => !isNaN(point.lat) && !isNaN(point.lng))}
            options={{
              strokeColor: "#810FCB",
              strokeOpacity: 1.0,
              strokeWeight: 2,
              fillColor: "#810FCB",
              fillOpacity: 0.5,
            }}
          />
        </React.Fragment>
      );
    });
  };

  const handleVillageSelectChange = (id) => {
    const newMarker = villagesList?.data?.data?.data.find(
      (item) => item?._id === id
    );
    if (newMarker) {
      setSelectedMarker(newMarker);
    }
  };

  const nameMap = {
    client: "Client",
    data_entry_operator: "DEO",
    constituency_manager: "Constituency Manager",
    office_manager: "Office Manager",
    chief_of_staff: "Chief of Staff",
    cadre: "Cadre",
  };

  if (loadError) {
    return <div className="loader">Error loading the map</div>;
  }

  if (isLoaded) {
    return (
      <>
        {loading && (
          <div className="loader">
            <div>Loading...</div>
          </div>
        )}
        <div className=" max-w-xs z-10 mt-6 ml-[1.9rem] flex items-center">
          <Select
            id="villageSelect"
            placeholder={"Select" + " " + "village/ward"}
            value={selectedMarker?.village_id}
            onChange={handleVillageSelectChange}
            className="mr-4"
            showSearch // Enable showSearch
            optionFilterProp="children" // Specify the property to filter on
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {(villagesList?.data?.data?.data || [])
              .filter((village) => village.villageName) // Optional: filter out unnamed villages
              .sort((a, b) => {
                const nameA = a.villageName || "";
                const nameB = b.villageName || "";
                return nameA.localeCompare(nameB);
              })
              .map((village) => (
                <Select.Option key={village?._id} value={village?._id}>
                  {village?.villageName || "Unnamed Village"}
                </Select.Option>
              ))}
          </Select>
        </div>
        <div className={`flex map-container1 px-[0px]`}>
          <div className={`flex map-container1 ${
            isFullScreen
              ? "fixed inset-0 bg-black bg-opacity-90 z-40 transition-opacity duration-500 ease-in-out"
              : ""
          }`}>
            <Tooltip title={isFullScreen ? "Exit Fullscreen" : "Fullscreen"}>
              <Button
                icon={isFullScreen ? <CloseOutlined /> : <FullscreenOutlined />}
                onClick={()=>(
                  toggleFullScreen(),
                  setIsActive((prev) => !prev)
                )}
                shape="circle"
                size="large"
                className={`handle-btn absolute z-10 top-[7.5rem] transition-none  ${isActive ? 'right-[3rem]' : 'left-[3rem]'}`}
                style={isActive ? { top: "2rem"} : {}}
              // style={`${isActive ? {top: "3rem", right: "3rem"} : {top: "40rem", left: "9.5rem"}}`}
                // disabled={!constituencyDataList || constituencyDataList.length === 0}
              />
            </Tooltip>

            <GoogleMap
              google={props.google}
              zoom={initialZoom}
              mapContainerClassName="map-container "
              // center={indiaCenter}
              options={{
                styles: themes === "darkMode" ? mapStyle : mapStyles,
                fullscreenControl: false,
                mapTypeControl: false,
                restriction: {
                  latLngBounds: indiaBounds,
                  strictBounds: true,
                },
              }}
              onLoad={onLoad}
              ref={mapRef}
            >
              {renderConstituencyPolygons()}
              {renderGrievanceMarkers()}
              {renderInfoWindow()}
            </GoogleMap>
          </div>

          <div className="flex flex-col w-full max-w-2xl gap-4 p-[1rem]">
            <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
              {/* Animated background elements */}
              <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-1/4 -left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-blue-400/10 to-transparent rounded-full blur-2xl animate-pulse"></div>
                <div 
                  className="absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-gradient-to-tl from-purple-400/10 to-transparent rounded-full blur-2xl animate-pulse"
                  style={{ animationDelay: "1s" }}
                ></div>
              </div>

              <div className="flex justify-between items-center relative z-10">
                <h3 className="text-xl font-bold text-black">
                  Insights
                </h3>
                <span className="bg-blue-600 text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg">
                  {loggedInUser?.role?.toUpperCase()}
                </span>
              </div>
            </div>
            {insightsLoading ? (
              <p>Loading insights...</p>
            ) : insightsError ? (
              <p>Error loading insights</p>
            ) : (
              <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
                {/* Animated background elements */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                  <div className="absolute -top-1/4 -left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-blue-400/10 to-transparent rounded-full blur-2xl animate-pulse"></div>
                  <div 
                    className="absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-gradient-to-tl from-purple-400/10 to-transparent rounded-full blur-2xl animate-pulse"
                    style={{ animationDelay: "1s" }}
                  ></div>
                </div>

                <div className="text-center text-lg font-bold mb-3 relative z-10 text-black">
                  Grievance count by Users
                </div>
                <div className="divide-y divide-gray-200/30 relative z-10">
                  {grievanceInsightsDataByRole?.data?.message?.data?.map(
                    (item, index) => {
                      const userName = item._id?.name || "Unknown";
                      const userRoleKey = item._id?.role?.toLowerCase();
                      const formattedRole =
                        nameMap[userRoleKey] ||
                        userRoleKey
                          ?.split("_")
                          .map((word, i) =>
                            i === 0
                              ? word
                              : word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join("");

                      return (
                        <div
                          key={index}
                          className="flex justify-between items-center px-3 py-2 text-l hover:bg-white/20 rounded transition-all duration-200"
                        >
                          <div className="flex flex-col">
                            <span className="font-medium text-black">
                              {userName}
                            </span>
                            <span className="text-xs text-gray-600">
                              {formattedRole}
                            </span>
                          </div>
                          <span className="text-l font-bold text-black bg-white/30 px-3 py-1 rounded-full backdrop-blur-sm">
                            {item.count}
                          </span>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            )}
            {insightsOfficeLoading ? (
              <p>Loading insights...</p>
            ) : insightsOfficeError ? (
              <p>Error loading insights</p>
            ) : (
              <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
                {/* Animated background elements */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                  <div className="absolute -top-1/4 -left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-blue-400/10 to-transparent rounded-full blur-2xl animate-pulse"></div>
                  <div 
                    className="absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-gradient-to-tl from-purple-400/10 to-transparent rounded-full blur-2xl animate-pulse"
                    style={{ animationDelay: "1s" }}
                  ></div>
                </div>

                <div className="text-center text-lg font-bold mb-3 relative z-10 text-black">
                  Office Assigned
                </div>
                <div className="divide-y divide-gray-200/30 relative z-10">
                  {grievanceInsightsDataByOffice?.data?.message?.data?.map(
                    (item, index) => {
                      const officeName = item.officeName || "Unknown";
                      const officeId = item.officeId;

                      return (
                        <div
                          key={officeId}
                          className="flex justify-between items-center px-3 py-2 text-l hover:bg-white/20 rounded transition-all duration-200"
                        >
                          <div className="flex flex-col">
                            <span className="font-medium text-black">
                              {officeName}
                            </span>
                          </div>
                          <span className="text-l font-bold text-black bg-white/30 px-3 py-1 rounded-full backdrop-blur-sm">
                            {item.count}
                          </span>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return <div className="loader">Loading...</div>;
  }
};

export default MapBox;
